<template>
  <auth-layout :title="$t('Reset Password')" :loading="loading">
    <template v-slot:body>
      <reset-password-form
        :initial-email="email"
        :token="token"
        login-href="/login"
        @loading="loading = $event"
      />
    </template>
  </auth-layout>
</template>
<script>
import ResetPasswordForm from '@shared/auth/ResetPasswordForm.vue';

export default {
  components: {
    ResetPasswordForm,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    token() {
      return this.$route.query.token || '';
    },
    email() {
      return this.$route.query.email || '';
    },
  },
};
</script>
